import type { GraphQLErrorLike } from '../utils/errorHandling'

const reasonMessages = {
  hostile_tone:
    'Please keep your post respectful and avoid insults, personal remarks, or mocking comments.',
  stock_availability:
    'Stock, restock, release, and preorder timing enquiries are best answered by our team. Please contact us about these.',
  method_discussion:
    'Please avoid revealing, guessing, or asking about secret methods. Questions about suitability and performance conditions are welcome.',
  product_critique:
    'Please use the review section for opinions about the product or trailer. This area is for product questions and helpful answers.',
  instruction_access:
    'Our team can help you find instructions or access passwords. Please contact us for help with these.',
  profanity: 'Please remove any profane or vulgar language from your post.',
} as const

type Reason = keyof typeof reasonMessages

export interface CommunityQuestionFeedback {
  kind: 'guidelines' | 'unavailable'
  messages: string[]
}

export function getCommunityQuestionFeedback(
  error: unknown
): CommunityQuestionFeedback | null {
  const errors = (error as GraphQLErrorLike | null)?.response?.errors
  if (!Array.isArray(errors)) return null

  const guidelineError = errors.find(
    item => item.extensions?.code === 'COMMUNITY_QUESTION_GUIDELINES'
  )
  if (guidelineError) {
    const extensions = guidelineError.extensions as Record<string, unknown>
    const rawReasons = extensions.communityQuestionReasons
    const reasons = Array.isArray(rawReasons)
      ? [...new Set(rawReasons)].filter(
          (reason): reason is Reason =>
            typeof reason === 'string' &&
            Object.prototype.hasOwnProperty.call(reasonMessages, reason)
        )
      : []
    return {
      kind: 'guidelines',
      messages: reasons.length
        ? reasons.map(reason => reasonMessages[reason])
        : [
            'Please check the guidelines above and adjust your post before trying again.',
          ],
    }
  }

  if (
    errors.some(
      item => item.extensions?.code === 'COMMUNITY_QUESTION_CHECK_UNAVAILABLE'
    )
  ) {
    return { kind: 'unavailable', messages: [] }
  }
  return null
}
